/* eslint-disable max-len */
import type { AtomicPolicy, AtomicTaskInteraction } from './atomicTypes';
import { atomicsIntent } from './atomicTypes';

export enum atomicsViewNames {
  missing = 'missing',
  reviewYourPayment = 'review_your_payment',
  addressNormalizationShipping = 'address_normalization_shipping_interstitial',
  addressNormalizationShippingAndBilling = 'address_normalization_shipping_and_billing_interstitial',
  residentialAddressInterstitial = 'residential_address_interstitial',
  phoneConfirmationMultiFieldInterstitial = 'phone_confirmation_multi_field_interstitial',
  phoneConfirmationSCAInterstitial = 'phone_confirmation_sca_interstitial',
  phoneConfirmationRiskInterstitial = 'phone_confirmation_risk_interstitial',
  phoneConfirmationRiskBasedInterstitial = 'phone_confirmation_risk_based_interstitial',
  fiLimitExceededInterstitial = 'fi_limit_exceeded_interstitial',
  memberBenefitsGuestInterstitial = 'member_benefits_guest_interstitial',
  sepaInterstitial = 'sepa_interstitial',
}

export enum atomicsTasks {
  missing = 'missing',
  addressNormalizationShipping = 'contingency_address_norm_recommendation_shipping',
  addressNormalizationShippingAndBilling = 'contingency_address_norm_recommendation_shipping_and_billing',
  selectAgreeAndCreateAccountContinuePayLater = 'select_agree_and_create_account_pay_later',
  selectAgreeAndCreateAccountContinuePayLaterOnly = 'select_agree_and_create_account_google_pay_later_only',
  addResidentialAddress = 'add_residential_address',
  viewSepaInterstitial = 'view_sepa_interstitial',
  contingencyMemberBenefitsGuest = 'contingency_account_benefits_user_input',
  contingencyFILimitExceeded = 'contingency_fi_limit_exceeded',
  contingencyPhoneConfirmation = 'contingency_phone_confirmation',
  reviewYourPayment = 'review_your_payment',
  selectContinueAsGuest = 'select_continue_as_guest',
  selectCreateAccountAndContinue = 'select_create_account_and_continue',
  selectPayLaterOptionsLink = 'select_pay_later_options_link',
  submitPayLater = 'submit_pay_later',
  submitPayLaterOnly = 'submit_google_pay_later_only',
}

export enum atomicsFlows {
  guestAndSignup = 'guest',
}

export enum atomicsStatus {
  ok = 'Ok',
  error = 'Error',
  fci = 'FCI',
  start = 'Start',
}

export enum atomicsErrorReason {
  none = 'None',
  server = 'Server',
  flag = 'Flag',
  user = 'User',
  thirdParty = 'ThirdParty',
  network = 'Network',
  application = 'Application',
  auth = 'Auth',
}

export enum atomicsErrorContexts {
  addressNormalization = 'ADDRESS_NORMALIZATION_INTERSTITIAL',
  fiLimitExceeded = 'FI_LIMIT_EXCEEDED',
  invalidFormSubmission = 'INVALID_FORM_SUBMISSION',
  invalidResidentialAddress = 'INVALID_RESIDENTIAL_ADDRESS_IN_INTERSTITIAL',
  shippingCallback = 'SHIPPING_CALLBACK',
  shippingRegionUnsupported = 'SHIPPING_REGION_UNSUPPORTED',
  memberBenefitsTrueGuest = 'MEMBER_BENEFITS_TRUE_GUEST',
}

export const atomicsDomain = 'xo_legacy_guest' as const;

export const policy: AtomicPolicy<
  atomicsViewNames,
  AtomicTaskInteraction<atomicsTasks>,
  atomicsTasks,
  atomicsFlows
> = {
  flows: Object.values(atomicsFlows),
  interactions: Object.values(atomicsTasks).flatMap(task => [
    `${atomicsIntent.cancel}_${task}`,
    `${atomicsIntent.click}_${task}`,
    `${atomicsIntent.submit}_${task}`,
  ]) as AtomicTaskInteraction<atomicsTasks>[],
  tasks: Object.values(atomicsTasks),
  viewNames: Object.values(atomicsViewNames),
};

export type AtomicEventsAttributes = {
  domain?: typeof atomicsDomain;
  flow?: atomicsFlows;
  intent: AtomicTaskInteraction<atomicsTasks>;
  task?: atomicsTasks;
  viewName: atomicsViewNames;
};
